import { JSX } from 'solid-js/jsx-runtime';
import { mergeProps, splitProps } from 'solid-js';

export const ExpandIcon = (props: JSX.SvgSVGAttributes<SVGSVGElement>) => {
  const merged = mergeProps(
    {
      width: 32,
      height: 32,
    },
    props,
  );

  const [local, rest] = splitProps(merged, ['width', 'height']);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      {...local}
      {...rest}
    >
      <path d="M216,48V96a8,8,0,0,1-16,0V67.31l-50.34,50.35a8,8,0,0,1-11.32-11.32L188.69,56H160a8,8,0,0,1,0-16h48A8,8,0,0,1,216,48ZM106.34,138.34,56,188.69V160a8,8,0,0,0-16,0v48a8,8,0,0,0,8,8H96a8,8,0,0,0,0-16H67.31l50.35-50.34a8,8,0,0,0-11.32-11.32Z" />
    </svg>
  );
};
